import { ITableColumnMetadata } from '../../components/CustomTable/interfaces';

const tableColumnMetadata: ITableColumnMetadata[] = [
  { key: 'code', displayName: 'ID' },
  { key: 'customer.business.ruc', displayName: 'RUC' },
  { key: 'customer.business.name', displayName: 'Empresa' },
  { key: 'customer.name', displayName: 'Cliente' },
  { key: 'customer.email', displayName: 'Correo electrónico' },
  { key: 'creationDate', displayName: 'Fecha de creación', type: 'datetime' },
  { key: 'finishDate', displayName: 'Fecha fin', type: 'datetime' },
  { key: 'time', displayName: 'Tiempo transcurrido', type: 'time' },
  {
    key: 'status',
    displayName: 'Estado',
    type: 'status',
    statusMap: {
      PENDING: { text: 'Pendiente', background: 'warning' },
      APPROVED: { text: 'Aprobado', background: 'success' },
      REJECTED: { text: 'Rechazado', background: 'danger' }
    }
  }
];

export default tableColumnMetadata;
